import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faUserSecret,
  faPlus,
  faTrashAlt,
  faChevronUp,
  faChevronDown,
  faPen,
  faCopy,
  faTimes,
  faChevronCircleUp,
  faChevronCircleDown,
  faPlusCircle,
  faMinusCircle,
  faClock,
  faUsers,
} from "@fortawesome/free-solid-svg-icons";

library.add(
  faUserSecret,
  faPlus,
  faTrashAlt,
  faChevronUp,
  faChevronDown,
  faPen,
  faCopy,
  faTimes,
  faChevronCircleUp,
  faChevronCircleDown,
  faPlusCircle,
  faMinusCircle,
  faClock,
  faUsers
);

export default library;
